
import { Vue, Component } from "vue-property-decorator";
import dayjs from "dayjs";
@Component({
  name: "goodsCategory",
})

export default class goodsCategory extends Vue {
	
  data(){
	  return{
		dialogVisible: false,
		dialogTitle:'',
		productAttrCate:{
		  name:'',
		  id:null
		},  
		rules: {
		  name: [
		    { required: true, message: '请输入类型名称', trigger: 'blur' }
		  ]
		},
		settleType:1
	  }
  };
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form = {};
  private secondData: Array<any> = [];
  private get pagedTableData() {
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
    let datas = [];
    let paramter = {
		'pageNum':1,
		'pageSize':10000,
		'level':1
    };
	this.$http.get('goodsType/list',{params:paramter},{
	    emulateJSON:true }).then(result =>{
			datas = result.data.data.data;
			this.tableData = datas;
			this.tableData = this.tableData.map(item=>{
			
				if(item.enable == 1) {

					item.enable = true;
				} else {

					item.enable = false;
				}
				return item;
			});
		console.log('====',this.tableData);
	})
  }
  
  private getAttrList(index, row) {
    
	console.log(row);
	this.$router.push({path: '/Brand/brandSecondType',query:{cid:row.id,cname:row.name,parentid:row.parentId}})
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
  }

  private onSubmit() {
    console.log(this.form);
  }
  private addSubmit() {
	  
	  this.settleType = 1;
      this.dialogVisible = true;
	  this.dialogTitle = "新增类型";
  }
  private handleClose() {
	
	this.dialogVisible = false;
  }
  private handleUpdate(index:any, row:any){
	  
	  this.settleType = 2;
	  this.dialogVisible = true;
	  this.dialogTitle = "编辑类型";
	  this.productAttrCate.name = row.name;
	  this.productAttrCate.id = row.id;
  }
  private handleDelete(index:any, row:any){
	  // 删除类型
	  this.$http.delete("goodsType/delete/"+row.id,{}).then((res: any) =>{
	  	
	  		this.$confirm('删除成功');
	  		this.dialogVisible = false;
			window.location.reload();
	  });
  }
  private sureSubmit(value:any){
	  
	  let settleType = value; //settleType：1 表示新增品类，2表示编辑评论
	  
	  if(settleType == 1) {
		  
		  // 新增品类
		  let paramter = {
		  	level:1,
		  	name:this.productAttrCate.name,
		  	parentId:0,
		  };
		  this.$http.post("goodsType/add/", paramter).then((res: any) =>{
		  	
		  		this.$confirm('修改成功');
		  		this.dialogVisible = false;
				window.location.reload();
		  	// this.tableData = res.data;
		  });
		  
	  } else  {
		  // 编辑品类
		  let paramter = {
		  	level:1,
		  	name:this.productAttrCate.name,
		  	parentId:0,
		  };
		  this.$http.put("goodsType/edit/"+this.productAttrCate.id, paramter).then((res: any) =>{
		  	
				this.dialogVisible = false;
		  		this.$confirm('修改成功');
				window.location.reload();
				this.tableData = res.data.data.data;
		  });
	  }
	  
  }
  private userStateChange(item:any){
	  
	  // 是否开启类型
	  // 编辑类型
	  var itemTemp = item;
	  if(item.enable == true) {
		  
		  let paramter = {
		  	id:itemTemp.id,
		  };
		  this.$http.delete("goodsType/on/"+itemTemp.id, {body:paramter}).then((res: any) =>{
		  	
				let data = res.data;
				if(data.code == 200) {
					
					this.$confirm(data.msg);
					window.location.reload();
				}
		  });
		   
	  } else {
		  
		  let paramter = {
		  	id:itemTemp.id,
		  };
		  this.$http.delete("goodsType/off/"+itemTemp.id, {body:paramter}).then((res: any) =>{
		  	
				let data = res.data;
				console.log('[[[[]]]]',data.msg);
				if(data.code == 200) {
					
					this.$confirm(data.msg);
					window.location.reload();
				}
		  		
		  });
	  }
  }
}
